export default [
  {
    text: "Lào Cai",
    children: [
      {
        text: "Thành phố Lào Cai"
      },
      {
        text: "Huyện Bát Xát"
      },
      {
        text: "Huyện Mường Khương"
      },
      {
        text: "Huyện Si Ma Cai"
      },
      {
        text: "Huyện Bắc Hà"
      },
      {
        text: "Huyện Bảo Thắng"
      },
      {
        text: "Huyện Bảo Yên"
      },
      {
        text: "Huyện Sa Pa"
      },
      {
        text: "Huyện Văn Bàn"
      }
    ]
  },
  {
    text: "Điện Biên",
    children: [
      {
        text: "Huyện Điện Biên"
      },
      {
        text: "Huyện Điện Biên Đông"
      },
      {
        text: "Huyện Mường Ảng"
      },
      {
        text: "Huyện Nậm Pồ"
      },
      {
        text: "Thành phố Điện Biên Phủ"
      },
      {
        text: "Thị xã Mường Lay"
      },
      {
        text: "Huyện Mường Nhé"
      },
      {
        text: "Huyện Mường Chà"
      },
      {
        text: "Huyện Tủa Chùa"
      },
      {
        text: "Huyện Tuần Giáo"
      }
    ]
  },
  {
    text: "Lai Châu",
    children: [
      {
        text: "Thành phố Lai Châu"
      },
      {
        text: "Huyện Tam Đường"
      },
      {
        text: "Huyện Mường Tè"
      },
      {
        text: "Huyện Sìn Hồ"
      },
      {
        text: "Huyện Phong Thổ"
      },
      {
        text: "Huyện Than Uyên"
      },
      {
        text: "Huyện Tân Uyên"
      },
      {
        text: "Huyện Nậm Nhùn"
      }
    ]
  },
  {
    text: "Sơn La",
    children: [
      {
        text: "Thành phố Sơn La"
      },
      {
        text: "Huyện Quỳnh Nhai"
      },
      {
        text: "Huyện Thuận Châu"
      },
      {
        text: "Huyện Mường La"
      },
      {
        text: "Huyện Bắc Yên"
      },
      {
        text: "Huyện Phù Yên"
      },
      {
        text: "Huyện Mộc Châu"
      },
      {
        text: "Huyện Yên Châu"
      },
      {
        text: "Huyện Mai Sơn"
      },
      {
        text: "Huyện Sông Mã"
      },
      {
        text: "Huyện Sốp Cộp"
      },
      {
        text: "Huyện Vân Hồ"
      }
    ]
  },
  {
    text: "Yên Bái",
    children: [
      {
        text: "Thành phố Yên Bái"
      },
      {
        text: "Thị xã Nghĩa Lộ"
      },
      {
        text: "Huyện Lục Yên"
      },
      {
        text: "Huyện Văn Yên"
      },
      {
        text: "Huyện Mù Căng Chải"
      },
      {
        text: "Huyện Trấn Yên"
      },
      {
        text: "Huyện Trạm Tấu"
      },
      {
        text: "Huyện Văn Chấn"
      },
      {
        text: "Huyện Yên Bình"
      }
    ]
  },
  {
    text: "Hòa Bình",
    children: [
      {
        text: "Thành phố Hòa Bình"
      },
      {
        text: "Huyện Đà Bắc"
      },
      {
        text: "Huyện Kỳ Sơn"
      },
      {
        text: "Huyện Lương Sơn"
      },
      {
        text: "Huyện Kim Bôi"
      },
      {
        text: "Huyện Cao Phong"
      },
      {
        text: "Huyện Tân Lạc"
      },
      {
        text: "Huyện Mai Châu"
      },
      {
        text: "Huyện Lạc Sơn"
      },
      {
        text: "Huyện Yên Thủy"
      },
      {
        text: "Huyện Lạc Thủy"
      }
    ]
  },
  {
    text: "Thái Nguyên",
    children: [
      {
        text: "Thành phố Thái Nguyên"
      },
      {
        text: "Thành phố Sông Công"
      },
      {
        text: "Huyện Định Hóa"
      },
      {
        text: "Huyện Phú Lương"
      },
      {
        text: "Huyện Đồng Hỷ"
      },
      {
        text: "Huyện Võ Nhai"
      },
      {
        text: "Huyện Đại Từ"
      },
      {
        text: "Thị xã Phổ Yên"
      },
      {
        text: "Huyện Phú Bình"
      }
    ]
  },
  {
    text: "Lạng Sơn",
    children: [
      {
        text: "Thành phố Lạng Sơn"
      },
      {
        text: "Huyện Tràng Định"
      },
      {
        text: "Huyện Bình Gia"
      },
      {
        text: "Huyện Văn Lãng"
      },
      {
        text: "Huyện Cao Lộc"
      },
      {
        text: "Huyện Văn Quan"
      },
      {
        text: "Huyện Bắc Sơn"
      },
      {
        text: "Huyện Hữu Lũng"
      },
      {
        text: "Huyện Chi Lăng"
      },
      {
        text: "Huyện Lộc Bình"
      },
      {
        text: "Huyện Đình Lập"
      }
    ]
  },
  {
    text: "Quảng Ninh",
    children: [
      {
        text: "Thành phố Hạ Long"
      },
      {
        text: "Thành phố Móng Cái"
      },
      {
        text: "Thành phố Cẩm Phả"
      },
      {
        text: "Thành phố Uông Bí"
      },
      {
        text: "Huyện Bình Liêu"
      },
      {
        text: "Huyện Tiên Yên"
      },
      {
        text: "Huyện Đầm Hà"
      },
      {
        text: "Huyện Hải Hà"
      },
      {
        text: "Huyện Ba Chẽ"
      },
      {
        text: "Huyện Vân Đồn"
      },
      {
        text: "Huyện Hoành Bồ"
      },
      {
        text: "Thị xã Đông Triều"
      },
      {
        text: "Thị xã Quảng Yên"
      },
      {
        text: "Huyện Cô Tô"
      }
    ]
  },
  {
    text: "Bắc Giang",
    children: [
      {
        text: "Thành phố Bắc Giang"
      },
      {
        text: "Huyện Yên Thế"
      },
      {
        text: "Huyện Tân Yên"
      },
      {
        text: "Huyện Lạng Giang"
      },
      {
        text: "Huyện Lục Nam"
      },
      {
        text: "Huyện Lục Ngạn"
      },
      {
        text: "Huyện Sơn Động"
      },
      {
        text: "Huyện Yên Dũng"
      },
      {
        text: "Huyện Việt Yên"
      },
      {
        text: "Huyện Hiệp Hòa"
      }
    ]
  },
  {
    text: "Phú Thọ",
    children: [
      {
        text: "Thành phố Việt Trì"
      },
      {
        text: "Thị xã Phú Thọ"
      },
      {
        text: "Huyện Đoan Hùng"
      },
      {
        text: "Huyện Hạ Hoà"
      },
      {
        text: "Huyện Thanh Ba"
      },
      {
        text: "Huyện Phù Ninh"
      },
      {
        text: "Huyện Yên Lập"
      },
      {
        text: "Huyện Cẩm Khê"
      },
      {
        text: "Huyện Tam Nông"
      },
      {
        text: "Huyện Lâm Thao"
      },
      {
        text: "Huyện Thanh Sơn"
      },
      {
        text: "Huyện Thanh Thuỷ"
      },
      {
        text: "Huyện Tân Sơn"
      }
    ]
  },
  {
    text: "Vĩnh Phúc",
    children: [
      {
        text: "Thành phố Vĩnh Yên"
      },
      {
        text: "Thị xã Phúc Yên"
      },
      {
        text: "Huyện Lập Thạch"
      },
      {
        text: "Huyện Tam Dương"
      },
      {
        text: "Huyện Tam Đảo"
      },
      {
        text: "Huyện Bình Xuyên"
      },
      {
        text: "Huyện Yên Lạc"
      },
      {
        text: "Huyện Vĩnh Tường"
      },
      {
        text: "Huyện Sông Lô"
      }
    ]
  },
  {
    text: "Bắc Ninh",
    children: [
      {
        text: "Thành phố Bắc Ninh"
      },
      {
        text: "Huyện Yên Phong"
      },
      {
        text: "Huyện Quế Võ"
      },
      {
        text: "Huyện Tiên Du"
      },
      {
        text: "Thị xã Từ Sơn"
      },
      {
        text: "Huyện Thuận Thành"
      },
      {
        text: "Huyện Gia Bình"
      },
      {
        text: "Huyện Lương Tài"
      }
    ]
  },
  {
    text: "Hải Dương",
    children: [
      {
        text: "Thành phố Hải Dương"
      },
      {
        text: "Thị xã Chí Linh"
      },
      {
        text: "Huyện Nam Sách"
      },
      {
        text: "Huyện Kinh Môn"
      },
      {
        text: "Huyện Kim Thành"
      },
      {
        text: "Huyện Thanh Hà"
      },
      {
        text: "Huyện Cẩm Giàng"
      },
      {
        text: "Huyện Bình Giang"
      },
      {
        text: "Huyện Gia Lộc"
      },
      {
        text: "Huyện Tứ Kỳ"
      },
      {
        text: "Huyện Ninh Giang"
      },
      {
        text: "Huyện Thanh Miện"
      }
    ]
  },
  {
    text: "Hải Phòng",
    children: [
      {
        text: "Quận Hồng Bàng"
      },
      {
        text: "Quận Ngô Quyền"
      },
      {
        text: "Quận Lê Chân"
      },
      {
        text: "Quận Hải An"
      },
      {
        text: "Quận Kiến An"
      },
      {
        text: "Quận Đồ Sơn"
      },
      {
        text: "Quận Dương Kinh"
      },
      {
        text: "Huyện Thuỷ Nguyên"
      },
      {
        text: "Huyện An Dương"
      },
      {
        text: "Huyện An Lão"
      },
      {
        text: "Huyện Kiến Thuỵ"
      },
      {
        text: "Huyện Tiên Lãng"
      },
      {
        text: "Huyện Vĩnh Bảo"
      },
      {
        text: "Huyện Cát Hải"
      }
    ]
  },
  {
    text: "Hưng Yên",
    children: [
      {
        text: "Thành phố Hưng Yên"
      },
      {
        text: "Huyện Văn Lâm"
      },
      {
        text: "Huyện Văn Giang"
      },
      {
        text: "Huyện Yên Mỹ"
      },
      {
        text: "Huyện Mỹ Hào"
      },
      {
        text: "Huyện Ân Thi"
      },
      {
        text: "Huyện Khoái Châu"
      },
      {
        text: "Huyện Kim Động"
      },
      {
        text: "Huyện Tiên Lữ"
      },
      {
        text: "Huyện Phù Cừ"
      }
    ]
  },
  {
    text: "Thái Bình",
    children: [
      {
        text: "Thành phố Thái Bình"
      },
      {
        text: "Huyện Quỳnh Phụ"
      },
      {
        text: "Huyện Hưng Hà"
      },
      {
        text: "Huyện Đông Hưng"
      },
      {
        text: "Huyện Thái Thụy"
      },
      {
        text: "Huyện Tiền Hải"
      },
      {
        text: "Huyện Kiến Xương"
      },
      {
        text: "Huyện Vũ Thư"
      }
    ]
  },
  {
    text: "Hà Nam",
    children: [
      {
        text: "Thành phố Phủ Lý"
      },
      {
        text: "Huyện Duy Tiên"
      },
      {
        text: "Huyện Kim Bảng"
      },
      {
        text: "Huyện Thanh Liêm"
      },
      {
        text: "Huyện Bình Lục"
      },
      {
        text: "Huyện Lý Nhân"
      }
    ]
  },
  {
    text: "Nam Định",
    children: [
      {
        text: "Thành phố Nam Định"
      },
      {
        text: "Huyện Mỹ Lộc"
      },
      {
        text: "Huyện Vụ Bản"
      },
      {
        text: "Huyện Ý Yên"
      },
      {
        text: "Huyện Nghĩa Hưng"
      },
      {
        text: "Huyện Nam Trực"
      },
      {
        text: "Huyện Trực Ninh"
      },
      {
        text: "Huyện Xuân Trường"
      },
      {
        text: "Huyện Giao Thủy"
      },
      {
        text: "Huyện Hải Hậu"
      }
    ]
  },
  {
    text: "Ninh Bình",
    children: [
      {
        text: "Thành phố Ninh Bình"
      },
      {
        text: "Thành phố Tam Điệp"
      },
      {
        text: "Huyện Nho Quan"
      },
      {
        text: "Huyện Gia Viễn"
      },
      {
        text: "Huyện Hoa Lư"
      },
      {
        text: "Huyện Yên Khánh"
      },
      {
        text: "Huyện Kim Sơn"
      },
      {
        text: "Huyện Yên Mô"
      }
    ]
  },
  {
    text: "Thanh Hóa",
    children: [
      {
        text: "Thành phố Thanh Hóa"
      },
      {
        text: "Thị xã Bỉm Sơn"
      },
      {
        text: "Thành phố Sầm Sơn"
      },
      {
        text: "Huyện Mường Lát"
      },
      {
        text: "Huyện Quan Hóa"
      },
      {
        text: "Huyện Bá Thước"
      },
      {
        text: "Huyện Quan Sơn"
      },
      {
        text: "Huyện Lang Chánh"
      },
      {
        text: "Huyện Ngọc Lặc"
      },
      {
        text: "Huyện Cẩm Thủy"
      },
      {
        text: "Huyện Thạch Thành"
      },
      {
        text: "Huyện Hà Trung"
      },
      {
        text: "Huyện Vĩnh Lộc"
      },
      {
        text: "Huyện Yên Định"
      },
      {
        text: "Huyện Thọ Xuân"
      },
      {
        text: "Huyện Thường Xuân"
      },
      {
        text: "Huyện Triệu Sơn"
      },
      {
        text: "Huyện Thiệu Hóa"
      },
      {
        text: "Huyện Hoằng Hóa"
      },
      {
        text: "Huyện Hậu Lộc"
      },
      {
        text: "Huyện Nga Sơn"
      },
      {
        text: "Huyện Như Xuân"
      },
      {
        text: "Huyện Như Thanh"
      },
      {
        text: "Huyện Nông Cống"
      },
      {
        text: "Huyện Đông Sơn"
      },
      {
        text: "Huyện Quảng Xương"
      },
      {
        text: "Huyện Tĩnh Gia"
      }
    ]
  },
  {
    text: "Nghệ An",
    children: [
      {
        text: "Thành phố Vinh"
      },
      {
        text: "Thị xã Cửa Lò"
      },
      {
        text: "Thị xã Thái Hoà"
      },
      {
        text: "Huyện Quế Phong"
      },
      {
        text: "Huyện Quỳ Châu"
      },
      {
        text: "Huyện Kỳ Sơn"
      },
      {
        text: "Huyện Tương Dương"
      },
      {
        text: "Huyện Nghĩa Đàn"
      },
      {
        text: "Huyện Quỳ Hợp"
      },
      {
        text: "Huyện Quỳnh Lưu"
      },
      {
        text: "Huyện Con Cuông"
      },
      {
        text: "Huyện Tân Kỳ"
      },
      {
        text: "Huyện Anh Sơn"
      },
      {
        text: "Huyện Diễn Châu"
      },
      {
        text: "Huyện Yên Thành"
      },
      {
        text: "Huyện Đô Lương"
      },
      {
        text: "Huyện Thanh Chương"
      },
      {
        text: "Huyện Nghi Lộc"
      },
      {
        text: "Huyện Nam Đàn"
      },
      {
        text: "Huyện Hưng Nguyên"
      },
      {
        text: "Thị xã Hoàng Mai"
      }
    ]
  },
  {
    text: "Hà Tĩnh",
    children: [
      {
        text: "Thành phố Hà Tĩnh"
      },
      {
        text: "Thị xã Hồng Lĩnh"
      },
      {
        text: "Huyện Hương Sơn"
      },
      {
        text: "Huyện Đức Thọ"
      },
      {
        text: "Huyện Vũ Quang"
      },
      {
        text: "Huyện Nghi Xuân"
      },
      {
        text: "Huyện Can Lộc"
      },
      {
        text: "Huyện Hương Khê"
      },
      {
        text: "Huyện Thạch Hà"
      },
      {
        text: "Huyện Cẩm Xuyên"
      },
      {
        text: "Huyện Kỳ Anh"
      },
      {
        text: "Huyện Lộc Hà"
      },
      {
        text: "Thị xã Kỳ Anh"
      }
    ]
  },
  {
    text: "Quảng Bình",
    children: [
      {
        text: "Thành Phố Đồng Hới"
      },
      {
        text: "Huyện Minh Hóa"
      },
      {
        text: "Huyện Tuyên Hóa"
      },
      {
        text: "Huyện Quảng Trạch"
      },
      {
        text: "Huyện Bố Trạch"
      },
      {
        text: "Huyện Quảng Ninh"
      },
      {
        text: "Huyện Lệ Thủy"
      },
      {
        text: "Thị xã Ba Đồn"
      }
    ]
  },
  {
    text: "Quảng Trị",
    children: [
      {
        text: "Thành phố Đông Hà"
      },
      {
        text: "Thị xã Quảng Trị"
      },
      {
        text: "Huyện Vĩnh Linh"
      },
      {
        text: "Huyện Hướng Hóa"
      },
      {
        text: "Huyện Gio Linh"
      },
      {
        text: "Huyện Đa Krông"
      },
      {
        text: "Huyện Cam Lộ"
      },
      {
        text: "Huyện Triệu Phong"
      },
      {
        text: "Huyện Hải Lăng"
      }
    ]
  },
  {
    text: "Thừa Thiên Huế",
    children: [
      {
        text: "Thành phố Huế"
      },
      {
        text: "Huyện Phong Điền"
      },
      {
        text: "Huyện Quảng Điền"
      },
      {
        text: "Huyện Phú Vang"
      },
      {
        text: "Thị xã Hương Thủy"
      },
      {
        text: "Thị xã Hương Trà"
      },
      {
        text: "Huyện A Lưới"
      },
      {
        text: "Huyện Phú Lộc"
      },
      {
        text: "Huyện Nam Đông"
      }
    ]
  },
  {
    text: "Đà Nẵng",
    children: [
      {
        text: "Quận Liên Chiểu"
      },
      {
        text: "Quận Thanh Khê"
      },
      {
        text: "Quận Hải Châu"
      },
      {
        text: "Quận Sơn Trà"
      },
      {
        text: "Quận Ngũ Hành Sơn"
      },
      {
        text: "Quận Cẩm Lệ"
      },
      {
        text: "Huyện Hòa Vang"
      }
    ]
  },
  {
    text: "Quảng Nam",
    children: [
      {
        text: "Thành phố Tam Kỳ"
      },
      {
        text: "Thành phố Hội An"
      },
      {
        text: "Huyện Tây Giang"
      },
      {
        text: "Huyện Đông Giang"
      },
      {
        text: "Huyện Đại Lộc"
      },
      {
        text: "Thị xã Điện Bàn"
      },
      {
        text: "Huyện Duy Xuyên"
      },
      {
        text: "Huyện Quế Sơn"
      },
      {
        text: "Huyện Nam Giang"
      },
      {
        text: "Huyện Phước Sơn"
      },
      {
        text: "Huyện Hiệp Đức"
      },
      {
        text: "Huyện Thăng Bình"
      },
      {
        text: "Huyện Tiên Phước"
      },
      {
        text: "Huyện Bắc Trà My"
      },
      {
        text: "Huyện Nam Trà My"
      },
      {
        text: "Huyện Núi Thành"
      },
      {
        text: "Huyện Phú Ninh"
      },
      {
        text: "Huyện Nông Sơn"
      }
    ]
  },
  {
    text: "Quảng Ngãi",
    children: [
      {
        text: "Thành phố Quảng Ngãi"
      },
      {
        text: "Huyện Bình Sơn"
      },
      {
        text: "Huyện Trà Bồng"
      },
      {
        text: "Huyện Tây Trà"
      },
      {
        text: "Huyện Sơn Tịnh"
      },
      {
        text: "Huyện Tư Nghĩa"
      },
      {
        text: "Huyện Sơn Hà"
      },
      {
        text: "Huyện Sơn Tây"
      },
      {
        text: "Huyện Minh Long"
      },
      {
        text: "Huyện Nghĩa Hành"
      },
      {
        text: "Huyện Mộ Đức"
      },
      {
        text: "Huyện Đức Phổ"
      },
      {
        text: "Huyện Ba Tơ"
      },
      {
        text: "Huyện Lý Sơn"
      }
    ]
  },
  {
    text: "Bình Định",
    children: [
      {
        text: "Thành phố Qui Nhơn"
      },
      {
        text: "Huyện An Lão"
      },
      {
        text: "Huyện Hoài Nhơn"
      },
      {
        text: "Huyện Hoài Ân"
      },
      {
        text: "Huyện Phù Mỹ"
      },
      {
        text: "Huyện Vĩnh Thạnh"
      },
      {
        text: "Huyện Tây Sơn"
      },
      {
        text: "Huyện Phù Cát"
      },
      {
        text: "Thị xã An Nhơn"
      },
      {
        text: "Huyện Tuy Phước"
      },
      {
        text: "Huyện Vân Canh"
      }
    ]
  },
  {
    text: "Phú Yên",
    children: [
      {
        text: "Thành phố Tuy Hoà"
      },
      {
        text: "Thị xã Sông Cầu"
      },
      {
        text: "Huyện Đồng Xuân"
      },
      {
        text: "Huyện Tuy An"
      },
      {
        text: "Huyện Sơn Hòa"
      },
      {
        text: "Huyện Sông Hinh"
      },
      {
        text: "Huyện Tây Hoà"
      },
      {
        text: "Huyện Phú Hoà"
      },
      {
        text: "Huyện Đông Hòa"
      }
    ]
  },
  {
    text: "Khánh Hòa",
    children: [
      {
        text: "Thành phố Nha Trang"
      },
      {
        text: "Thành phố Cam Ranh"
      },
      {
        text: "Huyện Cam Lâm"
      },
      {
        text: "Huyện Vạn Ninh"
      },
      {
        text: "Thị xã Ninh Hòa"
      },
      {
        text: "Huyện Khánh Vĩnh"
      },
      {
        text: "Huyện Diên Khánh"
      },
      {
        text: "Huyện Khánh Sơn"
      },
      {
        text: "Huyện Trường Sa"
      }
    ]
  },
  {
    text: "Ninh Thuận",
    children: [
      {
        text: "Thành phố Phan Rang Tháp Chàm"
      },
      {
        text: "Huyện Bác Ái"
      },
      {
        text: "Huyện Ninh Sơn"
      },
      {
        text: "Huyện Ninh Hải"
      },
      {
        text: "Huyện Ninh Phước"
      },
      {
        text: "Huyện Thuận Bắc"
      },
      {
        text: "Huyện Thuận Nam"
      }
    ]
  },
  {
    text: "Bình Thuận",
    children: [
      {
        text: "Thành phố Phan Thiết"
      },
      {
        text: "Thị xã La Gi"
      },
      {
        text: "Huyện Tuy Phong"
      },
      {
        text: "Huyện Bắc Bình"
      },
      {
        text: "Huyện Hàm Thuận Bắc"
      },
      {
        text: "Huyện Hàm Thuận Nam"
      },
      {
        text: "Huyện Tánh Linh"
      },
      {
        text: "Huyện Đức Linh"
      },
      {
        text: "Huyện Hàm Tân"
      },
      {
        text: "Huyện Phú Quí"
      }
    ]
  },
  {
    text: "Kon Tum",
    children: [
      {
        text: "Thành phố Kon Tum"
      },
      {
        text: "Huyện Đắk Glei"
      },
      {
        text: "Huyện Ngọc Hồi"
      },
      {
        text: "Huyện Đắk Tô"
      },
      {
        text: "Huyện Kon Plông"
      },
      {
        text: "Huyện Kon Rẫy"
      },
      {
        text: "Huyện Đắk Hà"
      },
      {
        text: "Huyện Sa Thầy"
      },
      {
        text: "Huyện Tu Mơ Rông"
      },
      {
        text: "Huyện Ia H' Drai"
      }
    ]
  },
  {
    text: "Gia Lai",
    children: [
      {
        text: "Thành phố Pleiku"
      },
      {
        text: "Thị xã An Khê"
      },
      {
        text: "Thị xã Ayun Pa"
      },
      {
        text: "Huyện KBang"
      },
      {
        text: "Huyện Đăk Đoa"
      },
      {
        text: "Huyện Chư Păh"
      },
      {
        text: "Huyện Ia Grai"
      },
      {
        text: "Huyện Mang Yang"
      },
      {
        text: "Huyện Kông Chro"
      },
      {
        text: "Huyện Đức Cơ"
      },
      {
        text: "Huyện Chư Prông"
      },
      {
        text: "Huyện Chư Sê"
      },
      {
        text: "Huyện Đăk Pơ"
      },
      {
        text: "Huyện Ia Pa"
      },
      {
        text: "Huyện Krông Pa"
      },
      {
        text: "Huyện Phú Thiện"
      },
      {
        text: "Huyện Chư Pưh"
      }
    ]
  },
  {
    text: "Đắk Lắk",
    children: [
      {
        text: "Thành phố Buôn Ma Thuột"
      },
      {
        text: "Thị xã Buôn Hồ"
      },
      {
        text: "Huyện Ea H'leo"
      },
      {
        text: "Huyện Ea Súp"
      },
      {
        text: "Huyện Buôn Đôn"
      },
      {
        text: "Huyện Cư M'gar"
      },
      {
        text: "Huyện Krông Búk"
      },
      {
        text: "Huyện Krông Năng"
      },
      {
        text: "Huyện Ea Kar"
      },
      {
        text: "Huyện M'Đrắk"
      },
      {
        text: "Huyện Krông Bông"
      },
      {
        text: "Huyện Krông Pắc"
      },
      {
        text: "Huyện Krông A Na"
      },
      {
        text: "Huyện Lắk"
      },
      {
        text: "Huyện Cư Kuin"
      }
    ]
  },
  {
    text: "Đắk Nông",
    children: [
      {
        text: "Thị xã Gia Nghĩa"
      },
      {
        text: "Huyện Đăk Glong"
      },
      {
        text: "Huyện Cư Jút"
      },
      {
        text: "Huyện Đắk Mil"
      },
      {
        text: "Huyện Krông Nô"
      },
      {
        text: "Huyện Đắk Song"
      },
      {
        text: "Huyện Đắk R'Lấp"
      },
      {
        text: "Huyện Tuy Đức"
      }
    ]
  },
  {
    text: "Lâm Đồng",
    children: [
      {
        text: "Thành phố Đà Lạt"
      },
      {
        text: "Thành phố Bảo Lộc"
      },
      {
        text: "Huyện Đam Rông"
      },
      {
        text: "Huyện Lạc Dương"
      },
      {
        text: "Huyện Lâm Hà"
      },
      {
        text: "Huyện Đơn Dương"
      },
      {
        text: "Huyện Đức Trọng"
      },
      {
        text: "Huyện Di Linh"
      },
      {
        text: "Huyện Bảo Lâm"
      },
      {
        text: "Huyện Đạ Huoai"
      },
      {
        text: "Huyện Đạ Tẻh"
      },
      {
        text: "Huyện Cát Tiên"
      }
    ]
  },
  {
    text: "Bình Phước",
    children: [
      {
        text: "Thị xã Phước Long"
      },
      {
        text: "Thị xã Đồng Xoài"
      },
      {
        text: "Thị xã Bình Long"
      },
      {
        text: "Huyện Bù Gia Mập"
      },
      {
        text: "Huyện Lộc Ninh"
      },
      {
        text: "Huyện Bù Đốp"
      },
      {
        text: "Huyện Hớn Quản"
      },
      {
        text: "Huyện Đồng Phú"
      },
      {
        text: "Huyện Bù Đăng"
      },
      {
        text: "Huyện Chơn Thành"
      },
      {
        text: "Huyện Phú Riềng"
      }
    ]
  },
  {
    text: "Tây Ninh",
    children: [
      {
        text: "Thành phố Tây Ninh"
      },
      {
        text: "Huyện Tân Biên"
      },
      {
        text: "Huyện Tân Châu"
      },
      {
        text: "Huyện Dương Minh Châu"
      },
      {
        text: "Huyện Châu Thành"
      },
      {
        text: "Huyện Hòa Thành"
      },
      {
        text: "Huyện Gò Dầu"
      },
      {
        text: "Huyện Bến Cầu"
      },
      {
        text: "Huyện Trảng Bàng"
      }
    ]
  },
  {
    text: "Bình Dương",
    children: [
      {
        text: "Thành phố Thủ Dầu Một"
      },
      {
        text: "Huyện Bàu Bàng"
      },
      {
        text: "Huyện Dầu Tiếng"
      },
      {
        text: "Thị xã Bến Cát"
      },
      {
        text: "Huyện Phú Giáo"
      },
      {
        text: "Thị xã Tân Uyên"
      },
      {
        text: "Thị xã Dĩ An"
      },
      {
        text: "Thị xã Thuận An"
      },
      {
        text: "Huyện Bắc Tân Uyên"
      }
    ]
  },
  {
    text: "Đồng Nai",
    children: [
      {
        text: "Thành phố Biên Hòa"
      },
      {
        text: "Thị xã Long Khánh"
      },
      {
        text: "Huyện Tân Phú"
      },
      {
        text: "Huyện Vĩnh Cửu"
      },
      {
        text: "Huyện Định Quán"
      },
      {
        text: "Huyện Trảng Bom"
      },
      {
        text: "Huyện Thống Nhất"
      },
      {
        text: "Huyện Cẩm Mỹ"
      },
      {
        text: "Huyện Long Thành"
      },
      {
        text: "Huyện Xuân Lộc"
      },
      {
        text: "Huyện Nhơn Trạch"
      }
    ]
  },
  {
    text: "Bà Rịa Vũng Tàu",
    children: [
      {
        text: "Thành phố Vũng Tàu"
      },
      {
        text: "Thành phố Bà Rịa"
      },
      {
        text: "Huyện Châu Đức"
      },
      {
        text: "Huyện Xuyên Mộc"
      },
      {
        text: "Huyện Long Điền"
      },
      {
        text: "Huyện Đất Đỏ"
      },
      {
        text: "Huyện Tân Thành"
      }
    ]
  },
  {
    text: "Hồ Chí Minh",
    children: [
      {
        text: "Quận 1"
      },
      {
        text: "Quận 12"
      },
      {
        text: "Quận Thủ Đức"
      },
      {
        text: "Quận 9"
      },
      {
        text: "Quận Gò Vấp"
      },
      {
        text: "Quận Bình Thạnh"
      },
      {
        text: "Quận Tân Bình"
      },
      {
        text: "Quận Tân Phú"
      },
      {
        text: "Quận Phú Nhuận"
      },
      {
        text: "Quận 2"
      },
      {
        text: "Quận 3"
      },
      {
        text: "Quận 10"
      },
      {
        text: "Quận 11"
      },
      {
        text: "Quận 4"
      },
      {
        text: "Quận 5"
      },
      {
        text: "Quận 6"
      },
      {
        text: "Quận 8"
      },
      {
        text: "Quận Bình Tân"
      },
      {
        text: "Quận 7"
      },
      {
        text: "Huyện Củ Chi"
      },
      {
        text: "Huyện Hóc Môn"
      },
      {
        text: "Huyện Bình Chánh"
      },
      {
        text: "Huyện Nhà Bè"
      },
      {
        text: "Huyện Cần Giờ"
      }
    ]
  },
  {
    text: "Long An",
    children: [
      {
        text: "Thành phố Tân An"
      },
      {
        text: "Thị xã Kiến Tường"
      },
      {
        text: "Huyện Tân Hưng"
      },
      {
        text: "Huyện Vĩnh Hưng"
      },
      {
        text: "Huyện Mộc Hóa"
      },
      {
        text: "Huyện Tân Thạnh"
      },
      {
        text: "Huyện Thạnh Hóa"
      },
      {
        text: "Huyện Đức Huệ"
      },
      {
        text: "Huyện Đức Hòa"
      },
      {
        text: "Huyện Bến Lức"
      },
      {
        text: "Huyện Thủ Thừa"
      },
      {
        text: "Huyện Tân Trụ"
      },
      {
        text: "Huyện Cần Đước"
      },
      {
        text: "Huyện Cần Giuộc"
      },
      {
        text: "Huyện Châu Thành"
      }
    ]
  },
  {
    text: "Tiền Giang",
    children: [
      {
        text: "Thành phố Mỹ Tho"
      },
      {
        text: "Thị xã Gò Công"
      },
      {
        text: "Thị xã Cai Lậy"
      },
      {
        text: "Huyện Tân Phước"
      },
      {
        text: "Huyện Cái Bè"
      },
      {
        text: "Huyện Cai Lậy"
      },
      {
        text: "Huyện Châu Thành"
      },
      {
        text: "Huyện Chợ Gạo"
      },
      {
        text: "Huyện Gò Công Tây"
      },
      {
        text: "Huyện Gò Công Đông"
      },
      {
        text: "Huyện Tân Phú Đông"
      }
    ]
  },
  {
    text: "Bến Tre",
    children: [
      {
        text: "Thành phố Bến Tre"
      },
      {
        text: "Huyện Châu Thành"
      },
      {
        text: "Huyện Chợ Lách"
      },
      {
        text: "Huyện Mỏ Cày Nam"
      },
      {
        text: "Huyện Giồng Trôm"
      },
      {
        text: "Huyện Bình Đại"
      },
      {
        text: "Huyện Ba Tri"
      },
      {
        text: "Huyện Thạnh Phú"
      },
      {
        text: "Huyện Mỏ Cày Bắc"
      }
    ]
  },
  {
    text: "Trà Vinh",
    children: [
      {
        text: "Thành phố Trà Vinh"
      },
      {
        text: "Huyện Càng Long"
      },
      {
        text: "Huyện Cầu Kè"
      },
      {
        text: "Huyện Tiểu Cần"
      },
      {
        text: "Huyện Châu Thành"
      },
      {
        text: "Huyện Cầu Ngang"
      },
      {
        text: "Huyện Trà Cú"
      },
      {
        text: "Huyện Duyên Hải"
      },
      {
        text: "Thị xã Duyên Hải"
      }
    ]
  },
  {
    text: "Vĩnh Long",
    children: [
      {
        text: "Thành phố Vĩnh Long"
      },
      {
        text: "Huyện Long Hồ"
      },
      {
        text: "Huyện Mang Thít"
      },
      {
        text: "Huyện  Vũng Liêm"
      },
      {
        text: "Huyện Tam Bình"
      },
      {
        text: "Thị xã Bình Minh"
      },
      {
        text: "Huyện Trà Ôn"
      },
      {
        text: "Huyện Bình Tân"
      }
    ]
  },
  {
    text: "Đồng Tháp",
    children: [
      {
        text: "Thành phố Cao Lãnh"
      },
      {
        text: "Thành phố Sa Đéc"
      },
      {
        text: "Thị xã Hồng Ngự"
      },
      {
        text: "Huyện Tân Hồng"
      },
      {
        text: "Huyện Hồng Ngự"
      },
      {
        text: "Huyện Tam Nông"
      },
      {
        text: "Huyện Tháp Mười"
      },
      {
        text: "Huyện Cao Lãnh"
      },
      {
        text: "Huyện Thanh Bình"
      },
      {
        text: "Huyện Lấp Vò"
      },
      {
        text: "Huyện Lai Vung"
      },
      {
        text: "Huyện Châu Thành"
      }
    ]
  },
  {
    text: "An Giang",
    children: [
      {
        text: "Thành phố Long Xuyên"
      },
      {
        text: "Thành phố Châu Đốc"
      },
      {
        text: "Huyện An Phú"
      },
      {
        text: "Thị xã Tân Châu"
      },
      {
        text: "Huyện Phú Tân"
      },
      {
        text: "Huyện Châu Phú"
      },
      {
        text: "Huyện Tịnh Biên"
      },
      {
        text: "Huyện Tri Tôn"
      },
      {
        text: "Huyện Châu Thành"
      },
      {
        text: "Huyện Chợ Mới"
      },
      {
        text: "Huyện Thoại Sơn"
      }
    ]
  },
  {
    text: "Kiên Giang",
    children: [
      {
        text: "Thành phố Rạch Giá"
      },
      {
        text: "Thị xã Hà Tiên"
      },
      {
        text: "Huyện Kiên Lương"
      },
      {
        text: "Huyện Hòn Đất"
      },
      {
        text: "Huyện Tân Hiệp"
      },
      {
        text: "Huyện Châu Thành"
      },
      {
        text: "Huyện Giồng Riềng"
      },
      {
        text: "Huyện Gò Quao"
      },
      {
        text: "Huyện An Biên"
      },
      {
        text: "Huyện An Minh"
      },
      {
        text: "Huyện Vĩnh Thuận"
      },
      {
        text: "Huyện Phú Quốc"
      },
      {
        text: "Huyện Kiên Hải"
      },
      {
        text: "Huyện U Minh Thượng"
      },
      {
        text: "Huyện Giang Thành"
      }
    ]
  },
  {
    text: "Cần Thơ",
    children: [
      {
        text: "Quận Ninh Kiều"
      },
      {
        text: "Quận Ô Môn"
      },
      {
        text: "Quận Bình Thuỷ"
      },
      {
        text: "Quận Cái Răng"
      },
      {
        text: "Quận Thốt Nốt"
      },
      {
        text: "Huyện Vĩnh Thạnh"
      },
      {
        text: "Huyện Cờ Đỏ"
      },
      {
        text: "Huyện Phong Điền"
      },
      {
        text: "Huyện Thới Lai"
      }
    ]
  },
  {
    text: "Hậu Giang",
    children: [
      {
        text: "Thành phố Vị Thanh"
      },
      {
        text: "Thị xã Ngã Bảy"
      },
      {
        text: "Huyện Châu Thành A"
      },
      {
        text: "Huyện Châu Thành"
      },
      {
        text: "Huyện Phụng Hiệp"
      },
      {
        text: "Huyện Vị Thuỷ"
      },
      {
        text: "Huyện Long Mỹ"
      },
      {
        text: "Thị xã Long Mỹ"
      }
    ]
  },
  {
    text: "Sóc Trăng",
    children: [
      {
        text: "Thành phố Sóc Trăng"
      },
      {
        text: "Huyện Châu Thành"
      },
      {
        text: "Huyện Kế Sách"
      },
      {
        text: "Huyện Mỹ Tú"
      },
      {
        text: "Huyện Cù Lao Dung"
      },
      {
        text: "Huyện Long Phú"
      },
      {
        text: "Huyện Mỹ Xuyên"
      },
      {
        text: "Thị xã Ngã Năm"
      },
      {
        text: "Huyện Thạnh Trị"
      },
      {
        text: "Thị xã Vĩnh Châu"
      },
      {
        text: "Huyện Trần Đề"
      }
    ]
  },
  {
    text: "Bạc Liêu",
    children: [
      {
        text: "Thành phố Bạc Liêu"
      },
      {
        text: "Huyện Hồng Dân"
      },
      {
        text: "Huyện Phước Long"
      },
      {
        text: "Huyện Vĩnh Lợi"
      },
      {
        text: "Thị xã Giá Rai"
      },
      {
        text: "Huyện Đông Hải"
      },
      {
        text: "Huyện Hoà Bình"
      }
    ]
  },
  {
    text: "Cà Mau",
    children: [
      {
        text: "Thành phố Cà Mau"
      },
      {
        text: "Huyện U Minh"
      },
      {
        text: "Huyện Thới Bình"
      },
      {
        text: "Huyện Trần Văn Thời"
      },
      {
        text: "Huyện Cái Nước"
      },
      {
        text: "Huyện Đầm Dơi"
      },
      {
        text: "Huyện Năm Căn"
      },
      {
        text: "Huyện Phú Tân"
      },
      {
        text: "Huyện Ngọc Hiển"
      }
    ]
  },
  {
    text: "Tuyên Quang",
    children: [
      {
        text: "Thành phố Tuyên Quang"
      },
      {
        text: "Huyện Lâm Bình"
      },
      {
        text: "Huyện Nà Hang"
      },
      {
        text: "Huyện Chiêm Hóa"
      },
      {
        text: "Huyện Hàm Yên"
      },
      {
        text: "Huyện Yên Sơn"
      },
      {
        text: "Huyện Sơn Dương"
      }
    ]
  },
  {
    text: "Hà Nội",
    children: [
      {
        text: "Huyện Mê Linh"
      },
      {
        text: "Quận Hà Đông"
      },
      {
        text: "Thị xã Sơn Tây"
      },
      {
        text: "Huyện Ba Vì"
      },
      {
        text: "Huyện Phúc Thọ"
      },
      {
        text: "Huyện Đan Phượng"
      },
      {
        text: "Huyện Hoài Đức"
      },
      {
        text: "Huyện Quốc Oai"
      },
      {
        text: "Huyện Thạch Thất"
      },
      {
        text: "Huyện Chương Mỹ"
      },
      {
        text: "Huyện Thanh Oai"
      },
      {
        text: "Huyện Thường Tín"
      },
      {
        text: "Huyện Phú Xuyên"
      },
      {
        text: "Huyện Ứng Hòa"
      },
      {
        text: "Huyện Mỹ Đức"
      },
      {
        text: "Quận Ba Đình"
      },
      {
        text: "Quận Hoàn Kiếm"
      },
      {
        text: "Quận Tây Hồ"
      },
      {
        text: "Quận Long Biên"
      },
      {
        text: "Quận Cầu Giấy"
      },
      {
        text: "Quận Đống Đa"
      },
      {
        text: "Quận Hai Bà Trưng"
      },
      {
        text: "Quận Hoàng Mai"
      },
      {
        text: "Quận Thanh Xuân"
      },
      {
        text: "Huyện Sóc Sơn"
      },
      {
        text: "Huyện Đông Anh"
      },
      {
        text: "Huyện Gia Lâm"
      },
      {
        text: "Quận Nam Từ Liêm"
      },
      {
        text: "Huyện Thanh Trì"
      },
      {
        text: "Quận Bắc Từ Liêm"
      }
    ]
  },
  {
    text: "Hà Giang",
    children: [
      {
        text: "Thành phố Hà Giang"
      },
      {
        text: "Huyện Đồng Văn"
      },
      {
        text: "Huyện Mèo Vạc"
      },
      {
        text: "Huyện Yên Minh"
      },
      {
        text: "Huyện Quản Bạ"
      },
      {
        text: "Huyện Vị Xuyên"
      },
      {
        text: "Huyện Bắc Mê"
      },
      {
        text: "Huyện Hoàng Su Phì"
      },
      {
        text: "Huyện Xín Mần"
      },
      {
        text: "Huyện Bắc Quang"
      },
      {
        text: "Huyện Quang Bình"
      }
    ]
  },
  {
    text: "Cao Bằng",
    children: [
      {
        text: "Thành phố Cao Bằng"
      },
      {
        text: "Huyện Bảo Lâm"
      },
      {
        text: "Huyện Bảo Lạc"
      },
      {
        text: "Huyện Thông Nông"
      },
      {
        text: "Huyện Hà Quảng"
      },
      {
        text: "Huyện Trà Lĩnh"
      },
      {
        text: "Huyện Trùng Khánh"
      },
      {
        text: "Huyện Hạ Lang"
      },
      {
        text: "Huyện Quảng Uyên"
      },
      {
        text: "Huyện Phục Hoà"
      },
      {
        text: "Huyện Hoà An"
      },
      {
        text: "Huyện Nguyên Bình"
      },
      {
        text: "Huyện Thạch An"
      }
    ]
  },
  {
    text: "Bắc Kạn",
    children: [
      {
        text: "Thành Phố Bắc Kạn"
      },
      {
        text: "Huyện Pác Nặm"
      },
      {
        text: "Huyện Ba Bể"
      },
      {
        text: "Huyện Ngân Sơn"
      },
      {
        text: "Huyện Bạch Thông"
      },
      {
        text: "Huyện Chợ Đồn"
      },
      {
        text: "Huyện Chợ Mới"
      },
      {
        text: "Huyện Na Rì"
      }
    ]
  }
]